var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "buttons is-centered" }, [
    _vm.$i18n.locale === "br"
      ? _c(
          "div",
          [
            _c(
              "b-button",
              {
                staticClass: "is-button-secondary",
                attrs: {
                  id: "download-csv",
                  "icon-left": "far fa-file-csv",
                  rounded: "",
                },
                on: { click: _vm.downloadBoletos },
              },
              [_vm._v(" Baixar lista de boletos ")]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl" ||
    _vm.$i18n.locale === "br" ||
    _vm.$i18n.locale === "pe"
      ? _c(
          "div",
          [
            _c(
              "b-button",
              {
                staticClass: "is-button-secondary",
                attrs: {
                  id: "button-filter",
                  "data-cy": "button-filter",
                  "icon-left": "fas fa-filter",
                  rounded: "",
                },
                on: {
                  click: function ($event) {
                    return _vm.$emit("filters")
                  },
                },
              },
              [_vm._v(" Filtrar ")]
            ),
            _c(
              "b-button",
              {
                staticClass: "is-button-secondary",
                attrs: {
                  id: "download-excel",
                  "icon-left": "far fa-file-excel",
                  rounded: "",
                  disabled: _vm.clients.length === 0,
                },
                on: { click: _vm.downloadDefaultingClientsData },
              },
              [_vm._v(" Clientes Morosos ")]
            ),
          ],
          1
        )
      : _vm._e(),
    _vm.$i18n.locale === "cl"
      ? _c(
          "div",
          [
            _c(
              "b-tooltip",
              {
                attrs: {
                  label:
                    "Descarga las gestiones de mora de de estos clientes creadas en los últimos 60 días",
                },
              },
              [
                _c(
                  "b-button",
                  {
                    staticClass: "is-button-secondary",
                    attrs: {
                      id: "download-clients-defaults",
                      "icon-left": "far fa-file-excel",
                      loading: _vm.downloadingClientsDefaults,
                      rounded: "",
                    },
                    on: { click: _vm.downloadClientsDefaults },
                  },
                  [_vm._v(" Gestiones de mora ")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }